import { render, staticRenderFns } from "./LanguagesIcon.vue?vue&type=template&id=5a9e28a0&scoped=true&"
import script from "./LanguagesIcon.vue?vue&type=script&lang=ts&"
export * from "./LanguagesIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e28a0",
  null
  
)

export default component.exports